export default __webpack_public_path__ + "static/avatarPreviewImg-13b6a70113de345aa589d44cdd96a869.png";